module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-main md-scrollbar md-theme-default",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ready),
      expression: "ready"
    }],
    staticClass: "md-layout md-gutter"
  }, [_vm._l((_vm.accessDashboards), function(dashboard, index) {
    return (_vm.accessDashboards && Object.keys(_vm.accessDashboards).length) ? _c(dashboard, {
      key: index,
      tag: "component"
    }) : _vm._e()
  }), _c('div', {
    staticClass: "dashboard-card md-layout-item md-size-100"
  }, [_c('md-card', {
    attrs: {
      "id": "version-changes"
    }
  }, [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Последние изменения в стистеме")])]), _c('md-card-content', {
    domProps: {
      "innerHTML": _vm._s(_vm.versionChanges)
    }
  }, [_vm._v(_vm._s(_vm.versionChanges))])], 1)], 1)], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-943fde00","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 1219
// module chunks = 0